import { components, OptionProps } from "react-select";
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { SelectOption } from "@Modules/core/components/form/CustomReactSelect";

export default function TraderSelectOption (props: OptionProps<SelectOption>) {
  return (
      <components.Option {...props}>
        <CC.HStack>
          <CC.Avatar size={'sm'} src={'/assets/images/user.png'} />
          <CC.VStack
            display={{ base: 'none', md: 'flex' }}
            alignItems="flex-start"
            spacing="1px"
            ml="2"
          >
            <CC.Text fontSize="sm">{props.label}</CC.Text>
            <CC.Text fontSize="xs">
              {props.data.value}
            </CC.Text>
          </CC.VStack>
        </CC.HStack>
      </components.Option>
  );
};